/* AV Kart — website chat widget. Markup + config: snippets/avk-web-chat.liquid (window.AVKCHAT).
   API contract: avk-quotes-app docs/web-chat-api.md. Bot replies are plain text (rendered with textContent);
   only https://audiovisualkart.com links are made clickable. */
(function () {
  var CFG = window.AVKCHAT; if (!CFG) return;
  var root = document.getElementById('avkChat'); if (!root) return;

  // ---- switch: live flag, or a per-device preview flag from ?avkchat=1 / mock / 0 ----
  var LS = { get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
             set: function (k, v) { try { v == null ? localStorage.removeItem(k) : localStorage.setItem(k, v); } catch (e) {} } };
  var qp = new URLSearchParams(location.search), flag = qp.get('avkchat');
  if (flag === '0') LS.set('avkChatPreview', null); else if (flag === '1' || flag === 'mock') LS.set('avkChatPreview', flag);
  var preview = LS.get('avkChatPreview');
  if (!CFG.on && !preview) return;
  var MOCK = preview === 'mock';
  // Owner testing against a bot running on this computer: ?avkchatbase=http://localhost:8787/web-chat (preview only;
  // only localhost is accepted, so a link can't point the chat at someone else's server). ?avkchatbase=0 clears it.
  var lb = qp.get('avkchatbase');
  if (lb === '0') LS.set('avkChatBase', null);
  else if (lb && /^http:\/\/(localhost|127\.0\.0\.1)(:\d{2,5})?\/[\w\/-]*$/.test(lb)) LS.set('avkChatBase', lb.replace(/\/$/, ''));
  if (preview && LS.get('avkChatBase')) CFG.base = LS.get('avkChatBase');
  root.hidden = false;

  var $ = function (id) { return document.getElementById(id); };
  var fab = $('avkChatFab'), panel = $('avkChatPanel'), log = $('avkChatLog'), form = $('avkChatForm'),
      input = $('avkChatInput'), send = $('avkChatSend'), note = $('avkChatNote');
  var SID_KEY = 'avkChatSid', sid = LS.get(SID_KEY), started = false, busy = false, locked = false, consentText = '';

  function track(ev, extra) { try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: ev }, extra || {})); } catch (e) {} }

  // ---- page facts (never prices) ----
  function pageContext() {
    var t = CFG.template, sfx = CFG.templateSuffix, tpl = 'other';
    if (t === 'product' || t === 'collection' || t === 'cart') tpl = t;
    else if (t === 'page' && (sfx === 'ht-planner' || sfx === 'compatibility-checker')) tpl = 'page.' + sfx;
    var p = { url: location.pathname, template: tpl };
    if (CFG.productHandle) p.productHandle = CFG.productHandle;
    if (CFG.collectionHandle && t === 'collection') p.collectionHandle = CFG.collectionHandle;
    if (window.avkPlannerContext && !isCheckerOpen()) p.planner = clean(window.avkPlannerContext);
    var ck = checkerPicks(); if (ck) p.checker = ck;
    var utm = {}; ['source', 'medium', 'campaign'].forEach(function (k) { var v = qp.get('utm_' + k); if (v) utm[k] = v.slice(0, 80); });
    if (Object.keys(utm).length) p.utm = utm;
    if (cartItems && cartItems.length) p.cart = { items: cartItems };
    return p;
  }
  // Drop empty values, but keep a deliberate null for atmos/sub (= "none in this system", which the bot prices on).
  function clean(o) { var r = {}; Object.keys(o).forEach(function (k) { if ((o[k] != null && o[k] !== '') || (o[k] === null && (k === 'atmos' || k === 'sub'))) r[k] = o[k]; }); return r; }
  function isCheckerOpen() { var cc = document.querySelector('.avk-cc'); var s = cc && (cc.closest('.shopify-section') || cc); return !!(s && !s.classList.contains('avk-tt-hidden') && s.offsetParent); }
  function checkerPicks() {
    if (!document.querySelector('.avk-cc') || !isCheckerOpen()) return null;
    var u = new URLSearchParams(location.search), skip = { avr: 1, layout: 1, subs: 1, tab: 1, view: 1, preview_theme_id: 1, avkchat: 1 }, sp = [];
    u.forEach(function (v, k) { if (!skip[k] && k.indexOf('utm_') !== 0 && /^[a-z0-9-]+$/.test(v) && sp.indexOf(v) < 0) sp.push(v); });
    var avr = u.get('avr'); if (!avr && !sp.length) return null;
    var r = {}; if (avr) r.avr = avr; if (sp.length) r.speakers = sp.slice(0, 12); return r;
  }
  var cartItems = null;
  function loadCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
      .then(function (c) { cartItems = (c.items || []).slice(0, 20).map(function (i) { return { handle: i.handle, qty: i.quantity }; }); })
      .catch(function () {});
  }

  // ---- network ----
  // Real replies can take 15–30 s (longer with a pricing pass), so wait up to 90 s before giving up.
  function api(path, body, waitMs) {
    if (MOCK) return mockApi(path, body);
    var ctl = window.AbortController ? new AbortController() : null;
    var timer = ctl ? setTimeout(function () { ctl.abort(); }, waitMs || 90000) : null;
    return fetch(CFG.base + '/' + path, { method: 'POST', credentials: 'omit', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body), signal: ctl ? ctl.signal : undefined })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (d) { d._status = r.status; return d; }); })
      .then(function (d) { clearTimeout(timer); return d; }, function (e) { clearTimeout(timer); throw e; });
  }
  var tsReady = null;
  function turnstileToken() {
    if (!CFG.turnstileKey || MOCK) return Promise.resolve(undefined);
    if (!tsReady) tsReady = new Promise(function (res) {
      var s = document.createElement('script'); s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit'; s.async = true;
      s.onload = function () { res(); }; s.onerror = function () { res(); }; document.head.appendChild(s);
    });
    return tsReady.then(function () {
      if (!window.turnstile) return undefined;
      return new Promise(function (res) {
        var box = document.createElement('div'); box.style.display = 'none'; root.appendChild(box);
        try { window.turnstile.render(box, { sitekey: CFG.turnstileKey, size: 'invisible', callback: function (t) { res(t); }, 'error-callback': function () { res(undefined); } }); }
        catch (e) { res(undefined); }
        setTimeout(function () { res(undefined); }, 8000);
      });
    });
  }

  // ---- rendering ----
  function linkify(el, text) {
    var re = /https:\/\/(?:www\.)?audiovisualkart\.com\/[^\s<>"')]*/g, last = 0, m;
    while ((m = re.exec(text))) {
      el.appendChild(document.createTextNode(text.slice(last, m.index)));
      var a = document.createElement('a'); a.href = m[0]; a.textContent = m[0].replace(/^https:\/\/(?:www\.)?/, ''); el.appendChild(a);
      last = m.index + m[0].length;
    }
    el.appendChild(document.createTextNode(text.slice(last)));
  }
  function bubble(from, text) {
    if (!text) return;
    var d = document.createElement('div'); d.className = 'avkchat-msg ' + (from === 'customer' ? 'me' : 'bot');
    if (from === 'customer') d.textContent = text; else linkify(d, text);
    log.appendChild(d); scroll();
  }
  function scroll() { log.scrollTop = log.scrollHeight; }
  var typingEl = null;
  function typing(on) {
    if (on && !typingEl) { typingEl = document.createElement('div'); typingEl.className = 'avkchat-typing'; typingEl.textContent = 'Typing…'; log.appendChild(typingEl); scroll(); }
    if (!on && typingEl) { typingEl.remove(); typingEl = null; }
  }
  function money(cents) { try { return '₹' + Math.round(cents / 100).toLocaleString('en-IN'); } catch (e) { return ''; } }
  function cards(list) {
    if (!list || !list.length) return;
    var wrap = document.createElement('div'); wrap.className = 'avkchat-cards'; log.appendChild(wrap);
    list.slice(0, 6).forEach(function (p) {
      if (!p || !/^[a-z0-9-]+$/.test(p.handle || '')) return;
      fetch('/products/' + p.handle + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (d) {
        if (!d || (d.tags || []).indexOf('Discontinued') >= 0) return;
        var a = document.createElement('a'); a.className = 'avkchat-card'; a.href = '/products/' + d.handle;
        if (d.featured_image) { var im = document.createElement('img'); im.src = d.featured_image + (d.featured_image.indexOf('?') < 0 ? '?' : '&') + 'width=320'; im.alt = ''; im.loading = 'lazy'; im.width = 160; im.height = 90; a.appendChild(im); }
        var t = document.createElement('div'); t.textContent = d.title; a.appendChild(t);
        var pr = document.createElement('span'); pr.textContent = d.price > 0 ? money(d.price) : 'Price on request'; a.appendChild(pr);
        a.addEventListener('click', function () { track('avk_chat_product_click', { chat_product: d.handle }); });
        wrap.appendChild(a); scroll();
      }).catch(function () {});
    });
  }
  function actBox() { var b = document.createElement('div'); b.className = 'avkchat-act'; log.appendChild(b); return b; }
  function waButton(box, link, label, fallback) {
    var a = document.createElement(link ? 'a' : 'button'); a.className = 'avkchat-btn wa'; a.textContent = label || 'Continue on WhatsApp';
    if (link) { a.href = link; a.target = '_blank'; a.rel = 'noopener'; a.addEventListener('click', function () { track('avk_chat_whatsapp'); }); }
    else { a.type = 'button'; a.addEventListener('click', function () { goWhatsApp(fallback); }); }
    box.appendChild(a); scroll();
  }
  function okWa(l) { return typeof l === 'string' && /^https:\/\/(wa\.me|api\.whatsapp\.com)\//.test(l) ? l : null; }
  // Open the tab during the tap itself, then point it at the link: phone browsers block a window opened after a network wait.
  function goWhatsApp(fallbackLink, from) {
    track('avk_chat_whatsapp', from ? { chat_wa_from: from } : null);
    var w = null; try { w = window.open('', '_blank'); } catch (e) {}
    function go(l) {
      if (!l) { if (w) try { w.close(); } catch (e) {} fallbackGate(); return; }
      if (w && !w.closed) { try { w.opener = null; w.location.href = l; return; } catch (e) {} }
      location.href = l;
    }
    api('whatsapp', { sessionId: sid }, 15000).then(function (d) { go(okWa(d.waLink) || okWa(fallbackLink)); })
      .catch(function () { go(okWa(fallbackLink)); });
  }
  function fallbackGate() { var g = $('avkChatWaGate'); if (g) g.click(); }

  function numberBox(text, waLink) {
    var box = actBox();
    var row = document.createElement('div'); row.className = 'avkchat-num';
    var inp = document.createElement('input'); inp.type = 'tel'; inp.inputMode = 'tel'; inp.autocomplete = 'tel'; inp.placeholder = '10-digit mobile number'; inp.maxLength = 16; inp.setAttribute('aria-label', 'Mobile number');
    var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'avkchat-btn'; btn.textContent = 'Send';
    row.appendChild(inp); row.appendChild(btn); box.appendChild(row);
    var err = document.createElement('div'); err.className = 'avkchat-err'; err.hidden = true; box.appendChild(err);
    var p = document.createElement('p'); p.textContent = text || consentText; box.appendChild(p);
    // Second, equal choice: one tap to WhatsApp, nothing to type (the chat and the quote carry over).
    var or = document.createElement('div'); or.className = 'avkchat-or'; or.textContent = 'or'; box.appendChild(or);
    var wa = document.createElement('button'); wa.type = 'button'; wa.className = 'avkchat-btn wa'; wa.textContent = '📱 Continue on WhatsApp';
    wa.addEventListener('click', function () { goWhatsApp(waLink, 'ask_number'); });
    box.appendChild(wa);
    var wp = document.createElement('p'); wp.textContent = 'Opens WhatsApp with a ready message — send it and we reply there with your quote.'; box.appendChild(wp);
    function submit() {
      var raw = inp.value.trim();
      if (!validPhone(raw)) { err.textContent = 'Please enter a 10-digit mobile number'; err.hidden = false; inp.focus(); return; }
      err.hidden = true; btn.disabled = true; inp.disabled = true; typing(true);
      api('number', { sessionId: sid, phone: raw }).then(function (d) {
        typing(false);
        if (d._status === 400 && d.error === 'phone_invalid') { err.textContent = 'Please enter a 10-digit mobile number'; err.hidden = false; btn.disabled = false; inp.disabled = false; return; }
        if (!handleError(d)) { btn.disabled = false; inp.disabled = false; return; }
        box.remove(); bubble('customer', '📱 ' + raw);
        track('avk_chat_number');
        (d.replies || []).forEach(function (r) { bubble('bot', r.text); });
        if (!(d.replies || []).length) bubble('bot', 'Thanks! Go ahead with your question.');
        doAction(d.action);
      }).catch(function () { typing(false); btn.disabled = false; inp.disabled = false; err.textContent = 'Network problem — please try again'; err.hidden = false; });
    }
    btn.addEventListener('click', submit);
    inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); submit(); } });
    // No auto-focus on phones: the keyboard would cover the WhatsApp choice.
    scroll(); if (!(window.matchMedia && matchMedia('(pointer:coarse)').matches)) setTimeout(function () { inp.focus(); }, 50);
  }
  function validPhone(s) { var d = s.replace(/[\s-]/g, '').replace(/^(\+91|91|0)(?=\d{10}$)/, ''); return /^[6-9]\d{9}$/.test(d); }

  function doAction(a) {
    if (!a || a.type === 'none') return;
    if (a.type === 'ask_number') { track('avk_chat_ask_number'); numberBox(a.consentText, a.waLink); }
    else if (a.type === 'offer_whatsapp') { var b = actBox(); var p = document.createElement('p'); p.textContent = 'Want this plan or quote on WhatsApp? The chat carries over.'; b.appendChild(p); waButton(b, null, 'Send this on WhatsApp', a.waLink); }
    else if (a.type === 'handover') { var h = actBox(); if (a.text) { var q = document.createElement('p'); q.textContent = a.text; q.style.color = 'var(--ink)'; h.appendChild(q); } waButton(h, null, 'Continue on WhatsApp', a.waLink); track('avk_chat_handover'); }
    else if (a.type === 'checkout' && /^https:\/\/(www\.)?audiovisualkart\.com\/cart\//.test(a.url || '')) {
      var c = actBox(); var k = document.createElement('a'); k.className = 'avkchat-btn'; k.href = a.url; k.textContent = 'Buy now';
      k.addEventListener('click', function () { track('avk_chat_checkout'); }); c.appendChild(k); scroll();
    }
  }
  // true = carry on; false = handled as an error
  function handleError(d) {
    var s = d._status;
    if (!s || s === 200) return true;
    if (s === 400 && d.why === 'session') { LS.set(SID_KEY, null); sid = null; started = false; bubble('bot', 'Your chat expired — please send that again.'); start(); return false; }
    if (s === 429 || s === 503) {
      lock(); var b = actBox(); var p = document.createElement('p'); p.style.color = 'var(--ink)';
      p.textContent = d.text || 'Chat is busy right now — continue on WhatsApp.'; b.appendChild(p);
      waButton(b, d.waLink || null); return false;
    }
    bubble('bot', 'Sorry, something went wrong. Please try again.'); return false;
  }
  function lock() { locked = true; input.disabled = true; send.disabled = true; }

  // ---- flow ----
  function start() {
    if (started) return Promise.resolve(); started = true;
    typing(true);
    return Promise.all([turnstileToken(), loadCart()]).then(function (res) {
      return api('session', { sessionId: sid || undefined, turnstile: res[0], page: pageContext() });
    }).then(function (d) {
      typing(false);
      if (!handleError(d)) { if (d._status !== 400) started = false; return; }
      sid = d.sessionId; LS.set(SID_KEY, sid); consentText = d.consentText || '';
      note.textContent = ''; if (d.chatNote) { note.appendChild(document.createTextNode(d.chatNote + ' ')); var a = document.createElement('a'); a.href = CFG.privacyUrl; a.textContent = 'Privacy policy'; note.appendChild(a); }
      // One bubble per stored message; bubble() only ever sets text (no HTML).
      if (d.history && d.history.length) d.history.forEach(function (m) { if (m && typeof m.text === 'string') bubble(m.from, m.text); });
      else bubble('bot', d.greeting || 'Hi! Planning a home theatre or checking a product? Ask me anything.');
    }).catch(function () {
      typing(false); started = false;
      var b = actBox(); var p = document.createElement('p'); p.style.color = 'var(--ink)'; p.textContent = "Chat isn't available right now. Talk to us on WhatsApp instead."; b.appendChild(p); waButton(b, null);
    });
  }
  function retryLine(text, msg) {
    var b = actBox(); var p = document.createElement('p'); p.style.color = 'var(--ink)'; p.textContent = msg; b.appendChild(p);
    var r = document.createElement('button'); r.type = 'button'; r.className = 'avkchat-btn'; r.textContent = 'Try again';
    r.addEventListener('click', function () { if (busy || locked) return; b.remove(); sendMsg(text, true); });
    b.appendChild(r); scroll();
  }
  function sendMsg(text, isRetry) {
    if (busy || locked || !text) return;
    if (!sid) { start(); return; }
    busy = true; send.disabled = true;
    if (!isRetry) { bubble('customer', text); input.value = ''; grow(); }
    typing(true);
    track('avk_chat_message');
    api('message', { sessionId: sid, text: text, page: pageContext() }).then(function (d) {
      typing(false);
      if (!handleError(d)) return;
      var replies = (d.replies || []).filter(function (r) { return r && typeof r.text === 'string' && r.text.trim(); });
      replies.forEach(function (r) { bubble('bot', r.text); });
      cards(d.products); doAction(d.action);
      var acted = d.action && d.action.type && d.action.type !== 'none';
      if (!replies.length && !acted && !(d.products || []).length) retryLine(text, "Sorry, that reply didn't come through.");
    }).catch(function (e) {
      typing(false);
      retryLine(text, e && e.name === 'AbortError' ? 'This is taking longer than usual.' : 'Network problem — the message may not have sent.');
    }).then(function () { busy = false; if (!locked) send.disabled = false; });
  }
  function grow() {
    input.style.height = 'auto'; var h = Math.max(42, input.scrollHeight + 2);
    input.style.height = Math.min(h, 110) + 'px'; input.style.overflowY = h > 110 ? 'auto' : 'hidden';
  }

  // ---- soft invite (owner, 3 Nov 2026): a small bubble by the chat button after ~20 s on a product page or the
  // Planner / Checker. Once per visit; closing it keeps it away for a week; never while the chat is open, never on
  // cart or checkout, and not for someone who has already chatted.
  var invite = null;
  function hideInvite() { if (invite) { invite.remove(); invite = null; } }
  (function () {
    var t = pageContext().template;
    if (!(t === 'product' || t === 'page.ht-planner' || t === 'page.compatibility-checker')) return;
    if (/^\/(cart|checkout)/.test(location.pathname) || sid) return;
    var shown = false; try { shown = !!sessionStorage.getItem('avkChatInvite'); } catch (e) {}
    var closedAt = parseInt(LS.get('avkChatInviteClosed') || '0', 10);
    if (shown || (closedAt && Date.now() - closedAt < 7 * 864e5)) return;
    setTimeout(function () {
      if (panel.classList.contains('open') || fab.hidden || document.hidden) return;
      try { sessionStorage.setItem('avkChatInvite', '1'); } catch (e) {}
      invite = document.createElement('div'); invite.className = 'avkchat-invite'; invite.setAttribute('role', 'status');
      var msg = document.createElement('button'); msg.type = 'button'; msg.className = 'avkchat-invite__msg';
      msg.innerHTML = '<b>Need help choosing?</b> Ask me — replies in seconds.';
      var x = document.createElement('button'); x.type = 'button'; x.className = 'avkchat-invite__x'; x.setAttribute('aria-label', 'Close'); x.textContent = '×';
      invite.appendChild(msg); invite.appendChild(x); root.appendChild(invite);
      msg.addEventListener('click', function () { track('avk_chat_invite_click'); open(); });
      x.addEventListener('click', function () { track('avk_chat_invite_close'); LS.set('avkChatInviteClosed', String(Date.now())); hideInvite(); });
      track('avk_chat_invite_shown', { chat_page: t });
    }, 20000);
  })();

  function open() {
    hideInvite();
    panel.classList.add('open'); fab.hidden = true; fab.setAttribute('aria-expanded', 'true');
    track('avk_chat_open', { chat_page: CFG.template });
    start(); setTimeout(function () { input.focus(); }, 60);
  }
  function close() { panel.classList.remove('open'); fab.hidden = false; fab.setAttribute('aria-expanded', 'false'); fab.focus(); }
  fab.addEventListener('click', open);
  $('avkChatClose').addEventListener('click', close);
  panel.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  form.addEventListener('submit', function (e) { e.preventDefault(); sendMsg(input.value.trim().slice(0, 1000)); });
  input.addEventListener('input', grow);
  input.addEventListener('keydown', function (e) { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); form.requestSubmit ? form.requestSubmit() : sendMsg(input.value.trim()); } });
  window.avkOpenChat = open;

  // ---- ?avkchat=mock: a fake bot that follows the contract shapes, for design checks only ----
  var mock = { n: 0, num: false, held: null };
  function mockApi(path, body) {
    var wait = function (d) { return new Promise(function (r) { setTimeout(function () { d._status = d._status || 200; r(d); }, 500); }); };
    window.avkChatMockLast = { path: path, body: body };
    if (path === 'session') return wait({ sessionId: 'mock-session', hasNumber: mock.num, freeLeft: mock.num ? null : 3 - mock.n,
      consentText: "We'll use this number to share your quote and follow up on your enquiry.",
      chatNote: 'We save this chat to help with your enquiry. Ask "delete my chat" any time.',
      greeting: 'Hi! Planning a home theatre or checking a product? Ask me anything.', history: [] });
    if (path === 'number') {
      if (!validPhone(body.phone || '')) return wait({ _status: 400, error: 'phone_invalid' });
      mock.num = true; var h = mock.held; mock.held = null;
      return wait({ ok: true, replies: h ? [{ text: h }] : [], action: { type: 'none' } });
    }
    if (path === 'whatsapp') return wait({ code: 'AVK-MOCK', waLink: 'https://wa.me/?text=Continue%20my%20website%20chat%20AVK-MOCK' });
    if (path === 'message') {
      var t = (body.text || '').toLowerCase(); mock.n++;
      if (!mock.num && mock.n > 3) return wait({ replies: [{ text: 'Happy to keep helping — please share your mobile number to continue.' }], products: [], quickReplies: [], action: { type: 'ask_number', consentText: "We'll use this number to share your quote and follow up on your enquiry." } });
      if (/price|kitna|cost|quote|rate/.test(t) && !mock.num) { mock.held = '[mock] The exact price for that would be shown here.'; return wait({ replies: [{ text: 'Exact price aur quote bhejne ke liye apna mobile number share karein.' }], products: [], quickReplies: [], action: { type: 'ask_number', consentText: "We'll use this number to share your quote and follow up on your enquiry." } }); }
      if (/order|delivery|track/.test(t)) return wait({ replies: [], products: [], quickReplies: [], action: { type: 'handover', text: 'Our expert will take this forward with you on WhatsApp shortly.', waLink: 'https://wa.me/?text=mock' } });
      if (/buy/.test(t) && mock.num) return wait({ replies: [{ text: '[mock] Great — here is your cart.' }], products: [], quickReplies: [], action: { type: 'checkout', url: 'https://audiovisualkart.com/cart/1:1' } });
      return wait({ replies: [{ text: '[mock] I can see you are on ' + (body.page && body.page.url) + '.\nMore about the X1800H: https://audiovisualkart.com/products/denon-avr-x1800h-av-receiver' }],
        products: [{ handle: (body.page && body.page.productHandle) || 'denon-avr-x1800h-av-receiver' }], quickReplies: [],
        action: mock.n === 2 ? { type: 'offer_whatsapp', waLink: 'https://wa.me/?text=mock' } : { type: 'none' } });
    }
    return wait({ _status: 400, error: 'bad_request' });
  }
})();
